import { Icon } from './index'

export const RightTopArrow: Icon = ({ variant, disabled = false }) => (
	<svg
		className={disabled ? 'stroke-gray-400' : variant}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.78401 3.99316C5.78401 3.71702 6.00787 3.49316 6.28401 3.49316L12.0069 3.49316C12.1395 3.49316 12.2666 3.54584 12.3604 3.63961C12.4542 3.73338 12.5069 3.86056 12.5069 3.99316L12.5069 9.71601C12.5069 9.99216 12.283 10.216 12.0069 10.216C11.7307 10.216 11.5069 9.99216 11.5069 9.71602L11.5069 4.49316L6.28401 4.49316C6.00787 4.49316 5.78401 4.26931 5.78401 3.99316Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.63944 12.3604C3.44418 12.1651 3.44418 11.8485 3.63944 11.6533L11.5732 3.71954C11.7684 3.52428 12.085 3.52428 12.2803 3.71954C12.4755 3.91481 12.4755 4.23139 12.2803 4.42665L4.34655 12.3604C4.15129 12.5557 3.8347 12.5557 3.63944 12.3604Z"
		/>
	</svg>
)
